import { en, he } from 'src/locales';
import type { ILocaleType } from 'src/interfaces';

export const DEFAULT_LOCALE = 'en';

const LOCALE = window.CEMETERY_INSTALLATION === 'hebrew' ? 'he' : DEFAULT_LOCALE;

export const CURRENT_LOCALE = LOCALE as ILocaleType;

export const IS_HEBREW = LOCALE === 'he';

export const LOCALES = IS_HEBREW ? he : en;

export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
}

export const CURRENCY_SIGN = {
  en: '$',
  he: '₪',
};
